module.exports = __webpack_public_path__ + "img/11.a5a73a05.jpg";